import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const leadScoringApi = createApi({
  reducerPath: "leadScoringApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["LeadScores", "HotLeads", "ScoreStats"],
  endpoints: (build) => ({
    // Get hot leads
    getHotLeads: build.query({
      query: () => ({ url: "/lead-scoring/hot", method: "GET" }),
      providesTags: ["HotLeads"],
      transformResponse: (res) => res.data || [],
    }),

    // Get leaderboard (all clients ranked by score)
    getLeaderboard: build.query({
      query: (params = {}) => ({
        url: "/lead-scoring/leaderboard",
        method: "GET",
        params,
      }),
      providesTags: ["LeadScores"],
      transformResponse: (res) => res.data || { scores: [], total: 0 },
    }),

    // Get score for a specific client
    getClientScore: build.query({
      query: (clientId) => ({ url: `/lead-scoring/client/${clientId}`, method: "GET" }),
      providesTags: (result, error, clientId) => [{ type: "LeadScores", id: clientId }],
      transformResponse: (res) => res.data || null,
    }),

    // Get score distribution stats
    getScoreStats: build.query({
      query: () => ({ url: "/lead-scoring/stats", method: "GET" }),
      providesTags: ["ScoreStats"],
      transformResponse: (res) => res.data || { hot: 0, warm: 0, cool: 0, cold: 0, dead: 0, total: 0 },
    }),

    // Get scoring weights (for display)
    getScoringWeights: build.query({
      query: () => ({ url: "/lead-scoring/weights", method: "GET" }),
      transformResponse: (res) => res.data || {},
    }),

    // Manually record a scoring event
    recordScoringEvent: build.mutation({
      query: (body) => ({ url: "/lead-scoring/event", method: "POST", body }),
      invalidatesTags: ["LeadScores", "HotLeads", "ScoreStats"],
    }),

    // Recalculate all scores
    recalculateScores: build.mutation({
      query: () => ({ url: "/lead-scoring/recalculate", method: "POST" }),
      invalidatesTags: ["LeadScores", "HotLeads", "ScoreStats"],
    }),
  }),
});

export const {
  useGetHotLeadsQuery,
  useGetLeaderboardQuery,
  useGetClientScoreQuery,
  useGetScoreStatsQuery,
  useGetScoringWeightsQuery,
  useRecordScoringEventMutation,
  useRecalculateScoresMutation,
} = leadScoringApi;
